import { render, staticRenderFns } from "./TagsDropdown.vue?vue&type=template&id=f1bc60ce&scoped=true&"
import script from "./TagsDropdown.vue?vue&type=script&lang=ts&"
export * from "./TagsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./TagsDropdown.vue?vue&type=style&index=0&id=f1bc60ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bc60ce",
  null
  
)

export default component.exports